// Utilidad cn (className) para la aplicación Amarsi Control Panel
// Función helper para combinar clases de Tailwind CSS condicionalmente

import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Función cn - className utility
 * 
 * Combina clsx y tailwind-merge para permitir:
 * - Combinación condicional de clases
 * - Resolución de conflictos de Tailwind CSS
 * - Mejor rendimiento que template literals simples
 * 
 * @param {...any} inputs - Clases a combinar
 * @returns {string} String de clases combinadas y optimizadas
 */
export const cn = (...inputs) => {
  return twMerge(clsx(inputs));
};
